import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Make the service available application-wide
})
export class EventBusService {
  private projectCreatedSubject = new BehaviorSubject<void>(null); // Emit updates
  projectCreated$ = this.projectCreatedSubject.asObservable(); // Observable to subscribe to

  // Method to trigger an update
  triggerProjectCreatedEvent() {
    this.projectCreatedSubject.next();
  }
}